import { SalePerson } from '@gipi-sale/person/models/person.model';
import { BaseModel } from '@gipi-shared/models/base.model';
import { GIPIUuid, UUIDUtil } from '@gipisistemas/ng-core';
import { SaleCreditType } from './credit-type.model';

export class SaleClient extends BaseModel {

    person: SalePerson;

    maximumDelay: number;

    blocked: boolean;

    controlClientLimit: boolean;

    creditTypeList: SaleCreditType[];

    comments: string;

    ruralProducer: boolean;

    /** @Transient */
    selected: boolean;

    /** @Transient */
    storeCreditLimit: number;

    /** @Transient */
    bankSlipLimit: number;

    /** @Transient */
    checkLimit: number;

    constructor(id?: GIPIUuid) {
        super();
        if (UUIDUtil.isValid(id)) {
            this.id = id;
        }
    }

}
